import { gql } from '@apollo/client'

export const CREATE_SESSION = gql`
  mutation {
    createBillingPortalSession
  }
`
